import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Stopwatch20 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 448 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m398.5 190.91.59-.61 26.59-26.58a16 16 0 0 0 0-22.63L403 118.41a16 16 0 0 0-22.63 0l-24.68 24.68A206.68 206.68 0 0 0 256 98.5V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H160a16.05 16.05 0 0 0-16 16v32a16.05 16.05 0 0 0 16 16h32v34.5A207.92 207.92 0 0 0 16.09 297.57C12.64 411.5 106.76 510.22 220.72 512 337.13 513.77 432 420 432 304a206 206 0 0 0-33.5-113.09zM204.37 377.55a8.2 8.2 0 0 1 8.32 8.07v22.31a8.2 8.2 0 0 1-8.32 8.07h-82.85a16.46 16.46 0 0 1-16.61-17.62c2.78-35.22 14.67-57.41 38.45-91.37 20.42-29.19 27.1-37.32 27.1-62.34 0-16.92-1.79-24.27-12.21-24.27-9.39 0-12.69 7.4-12.69 22.68v5.23a8.2 8.2 0 0 1-8.33 8.07h-24.9a8.2 8.2 0 0 1-8.33-8.07v-4.07c0-27.3 8.48-60.24 56.43-60.24 43 0 55.57 25.85 55.57 61 0 35.58-12.44 51.21-34.35 81.31-11.56 15-24.61 35.57-26.41 51.2zM344 352.32c0 35.16-12.3 63.68-57.23 63.68-43.58 0-54.77-29.52-54.77-63.45V247.22c0-40.73 19.58-63.22 56.2-63.22 36.8 0 55.8 22.64 55.8 61.3zm-56.13-130.59c-9.41 0-13.23 7.5-13.23 20v115.95c0 13.11 3.59 20.59 13.23 20.59s13-8 13-21.27V241.06c.02-11.27-2.99-19.33-13-19.33z"
  }));
});
Stopwatch20.displayName = 'Stopwatch20';
export var Stopwatch20Dimensions = {
  height: 512,
  width: 448
};